import type { RouteObject } from "react-router-dom";
import Layout from "../components/feature/Layout";
import Home from "../pages/home/page";
import Category from "../pages/category/page";
import Detail from "../pages/detail/page";
import Actor from "../pages/actor/page";
import News from "../pages/news/page";
import Search from "../pages/search/page";
import About from "../pages/about/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/:genre", element: <Category /> },
      { path: "detail/:id", element: <Detail /> },
      { path: "actor/:id", element: <Actor /> },
      { path: "news", element: <News /> },
      { path: "search", element: <Search /> },
      { path: "about", element: <About /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;